import type { Distribution } from "@memorang/types";

const getRandomNumber = (max: number) => Math.floor(Math.random() * max) + 1;

const randomizeDistribution = (distribution: Distribution) => {
	for (const key in distribution) {
		if (key === "advanced") {
			distribution[key] = getRandomNumber(15) + 30;
		} else if (key === "highIntermediate") {
			distribution[key] = getRandomNumber(5);
		} else if (key === "none" || key === "basic") {
			distribution[key] = 0;
		} else {
			distribution[key] = getRandomNumber(4);
		}
	}
	return distribution;
};

const getRandomAvatar = (mockedAvatarUrls: string[]) => {
	const defaultAvatarUrl = "https://default-avatar-url.com/default-avatar.svg";

	const randomIndex = Math.floor(Math.random() * mockedAvatarUrls.length);
	return mockedAvatarUrls[randomIndex] || defaultAvatarUrl;
};
export { randomizeDistribution, getRandomNumber, getRandomAvatar };
